import React from 'react';
import { BookOpen, ChefHat, ArrowUpCircle, AlertTriangle, Sparkles } from 'lucide-react';
export function WhatIsIncluded() {
  const features = [{
    icon: BookOpen,
    text: 'Recetas de tortas clásicas que siempre funcionan'
  }, {
    icon: ChefHat,
    text: 'Tortas modernas fáciles de preparar'
  }, {
    icon: ArrowUpCircle,
    text: 'Técnicas para que las tortas queden altas y suaves'
  }, {
    icon: AlertTriangle,
    text: 'Los errores más comunes que arruinan una torta'
  }, {
    icon: Sparkles,
    text: 'Cómo lograr texturas perfectas en cada receta'
  }];
  return <section className="py-16 px-4 bg-[#FFF8F0]" data-id="element-167">
      <div className="max-w-5xl mx-auto" data-id="element-168">
        <h2 className="text-3xl md:text-4xl font-bold text-[#3C1518] text-center mb-12" data-id="element-169">
          Dentro del libro vas a descubrir:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-170">
          {features.map((feature, index) => <div key={index} className="bg-white p-6 rounded-2xl border border-[#E8D5C0] hover:border-[#EA580C]/50 transition-colors" data-id="element-171">
              <div className="w-12 h-12 bg-[#EA580C]/10 rounded-xl flex items-center justify-center mb-4" data-id="element-172">
                <feature.icon className="w-6 h-6 text-[#C2410C]" data-id="element-173" />
              </div>
              <p className="text-[#5C2D0E] font-medium leading-relaxed" data-id="element-174">
                {feature.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}